import { Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'app/services/user/user.service';
import { IPayment } from '../../models/payment';
import { PaymentService } from '../../service/payment.service';
import { AuthService } from '@shared/auth/auth.service';
import { SharedService } from '@shared/services/shared.service';

@Component({
  selector: 'app-pay-online',
  templateUrl: './pay-online.component.html',
  styleUrls: ['./pay-online.component.scss']
})

export class PayOnlineComponent implements OnInit {

  public processing: boolean = false;
  public cardColor: string = this.sharedService.blue + '20';
  public id: number = 0;
  public entityType: string = "";
  public payments: IPayment[] = [];
  public proceedButtonText = 'Proceed to Payment';
  public isValid: boolean = true;

  constructor(public paymentService: PaymentService,
              public sharedService: SharedService,
              public authService: AuthService,
              public userService: UserService,
              private route: ActivatedRoute) { }

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get("id");
    if (idParam != null) {
      this.id = +idParam;
    }

    this.route.queryParams.subscribe(
      params =>
      {
        this.entityType =  params['entityType'];
        this.loadPayment();
      });
  }

  payNow(id: number, licenseType: string) {
    this.processing = true;
    this.paymentService.negotiateToken(id, licenseType).subscribe({
      next: response => window.location.href = response,
      error: e => {
        this.processing = false;
        this.sharedService.toastr.error('Unable communicate with payment processor.  Please try again later.' + e.message);
      }
    });
  }

  loadPayment() {
    this.processing = true;
    this.userService.getUserLicenses().subscribe({
      next: response => {
        let license = response.find(l => l.id == this.id && l.payments != undefined && l.payments.some(p => !p.paid && p.entityType == this.entityType));
        if (license != null) {
          this.payments = license.payments.filter(p => !p.paid && p.entityType == this.entityType);
          if (this.payments != undefined && this.payments != null && this.payments.length > 0) {
            this.payments.forEach(p => {
              p.entityId = license.licenseId;
              p.entityName = license.name;
              this.isValid = true;
            });
          }
          else {
            this.sharedService.toastr.error('Unable get user payment info.');
            this.isValid = false;
          }
        }
        else {
          this.sharedService.toastr.error('Unable get user payment info.');
          this.isValid = false;
        }
        this.processing = false;
      },
      error: e => {
        this.processing = false;
        this.sharedService.toastr.error('Unable get user payment info.');
        this.isValid = false;
      }
    });
  }

  // loadPayments(){
  //   this.processing = true;
  //   this.userService.getUserPayements().subscribe({
  //     next: response => {
  //       this.payments = response.filter(p => !p.paid && p.entityType == this.entityType);
  //       if (this.payments != undefined && this.payments != null && this.payments.length > 0) {
  //         this.isValid = true;
  //       }
  //       else {
  //         this.sharedService.toastr.error('Unable get user payment info.');
  //         this.isValid = false;
  //       }
  //       this.processing = false;
  //     },
  //     error: e => {
  //       this.processing = false;
  //       this.sharedService.toastr.error('Unable get user payment info.');
  //       this.isValid = false;
  //     },
  //     complete: () => {
  //       this.payments.forEach(p => {
  //         p.entityName = this.entityType;
  //       });
  //     }
  //   });
  // }

}
